<script>
export default {
  name: 'WebDefault',
};
</script>

<template>
  <div>
    <p>The app should work offline on this device, or you can install the app on your phone or tablet</p>

    <h3>Install on mobile</h3>

    <ol>
      <li>
        On your phone or tablet, go to the URL
        <b>quetzal.app</b>
        <br />On iOS, open the website in Safari
      </li>
      <li>
        Open this
        <b>Offline</b> page to see install directions for your device
      </li>
    </ol>

    <p class="body-2">
      Note: This is a web app so you can install it on mobile from this page. Once you do, it works just like
      other apps&mdash;even offline. Plus, you never have to install updates and it works on every
      device.
    </p>
  </div>
</template>

